export const SkeletonTypes = {
	FILTER: 'filter',
	LIBRARY_CARD: 'library_card',
	MEDIA_RESOURCE_CARD: 'media_resource_card',
	NEWS_CARD: 'news_card',
};
